module.exports = __webpack_public_path__ + "img/8e04728.png";